/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./nls/StringResources'
], function(ServiceabilityStringResources){
	class ServiceabilityDataMapping{
		constructor(visualizationAPI) {
			this._visualizationAPI = visualizationAPI;
		}

		/**
		 * @returns {object} The result of this result should be an object which will
		 * be stringfied later.
		 * @description this method will fetch the data mapping info of a live widget
		 * through the APIs.
		 */
		toJSON() {
			const slotAPIs = this._visualizationAPI.getSlots().getSlotList();
			const jsonResult = slotAPIs.map((slotAPI) => {
				const slotDefinitionAPI = slotAPI.getDefinition();
				const dataItemAPIs = slotAPI.getDataItemList();
				return {
					[slotDefinitionAPI.getId()]: {
						'caption': slotDefinitionAPI.getCaption(),
						'mandatory': !(slotDefinitionAPI.isOptional() === true),
						'mapping': dataItemAPIs.map((dataItemAPI) => {return dataItemAPI.getColumnId();})
					}
				};
			});
			return jsonResult;
		}

		/**
		 * @description this method will fetch the data mapping info and construct a UI spec which defined
		 * how the Data Mapping section will be displayed
		 * @returns {object} The UI spec which will be consumed by ContentInfoAPI
		 */
		toUIJSON() {
			let headerData = {
				0: ServiceabilityStringResources.get('slotDataMapping'),
				1: ServiceabilityStringResources.get('slotID'),
				2: ServiceabilityStringResources.get('slotCaption'),
				3: ServiceabilityStringResources.get('slotMandatory')
			};

			let info = this.toJSON();
			let cellData = info.map((mappingSpec) => {
				let id = Object.keys(mappingSpec)[0];
				return [
					mappingSpec[id].mapping.join(', '),
					id,
					mappingSpec[id].caption,
					mappingSpec[id].mandatory ? ServiceabilityStringResources.get('slotIsMandatory') : ServiceabilityStringResources.get('slotIsNotMandatory')
				];
			});
			return [{
				fieldName: ServiceabilityStringResources.get('slotMappingField'),
				fieldValue: {
					headerValue: (col) => { return headerData[col]; },
					cellValue: (row, col) => { return cellData[row][col]; },
					columnLength: 4,
					rowLength: info.length
				},
				type: 'SimpleTable'
			}];
		}
	}
	return ServiceabilityDataMapping;
});
